import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tooltip, Whisper } from 'rsuite';
import { settingsPosTrackingMethodLocationsEditPath } from '../../../../../routes/Paths';
import pagePathToUrl from '../../../../../helpers/pagePathToUrl';
import IconLink from '../../../../IconLink';

const { Cell } = Table;

const ActionCell = ({ rowData, dataKey, ...props }) => {
  const { id } = rowData;
  return (
    <Cell {...props} className="link-group">
      <Whisper
        placement="top"
        trigger="hover"
        speaker={<Tooltip>Edit</Tooltip>}
      >
        <IconLink
          icon="edit2"
          to={pagePathToUrl(settingsPosTrackingMethodLocationsEditPath, { id })}
        />
      </Whisper>
    </Cell>
  );
};

ActionCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }),
  dataKey: PropTypes.string.isRequired
};

ActionCell.defaultProps = {
  rowData: null
};

export default ActionCell;
